import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import ActivationGate from "./ActivationGate";

export default function DashboardLayout() {
  const location = useLocation();
  return (
    <ActivationGate>
      <div className="min-h-screen bg-appbg">
        <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 border-r border-slate-200 shadow-[4px_0_24px_rgba(0,0,0,0.02)] lg:block">
          <Sidebar />
        </aside>
        <div className="lg:pl-64">
          <Topbar />
          <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <AnimatePresence mode="wait">
              <motion.div
                key={location.pathname}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.25, ease: "easeOut" }}
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          </main>
        </div>
      </div>
    </ActivationGate>
  );
}
